// extracted by mini-css-extract-plugin
export default {"title":"BluredTextBlock_title__am72r","titleBlock":"BluredTextBlock_titleBlock__-AASL","innerBlock":"BluredTextBlock_innerBlock__hitk7"};